/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react'
import { FormattedMessage } from 'react-intl';

import ArrowRight from '../../images/ArrowRight';
import Form from '../../common/Form';
import Text from '../../common/Text';
import { ExternalLink } from '../../common/TextLink';
import FlexRow from '../../common/FlexRow';
import { BackpackThemedContentPanelWithFullHeader } from "../../common/ContentPanel/ContentPanel";
import { WhiteCard } from "../../common/Card/Card";

const GroupDeletedView = () => {
  return (
    <BackpackThemedContentPanelWithFullHeader
      isFixedWidth
      titlePhrase={{ id: 'deleteGroupSuccess.title.text' }}
      subTitle={<FormattedMessage id="groupsetup.backpack.name" />}
    >
      <WhiteCard withPadding>
        <Form>
          <div>
            <Text size="body">
              <FormattedMessage id="deleteGroupSuccess.success.message.text" />
            </Text>
          </div>

          <div style={{ marginTop: 26 }}>
            <FlexRow>
              <div />
              <ExternalLink className="theme-group base color fill" target="" href={BPH_GROUPS_HOME}>
                <FormattedMessage id="deleteGroupSuccess.groupsHome.link.text" />
                <span style={{ width: 12 }}> </span>
                <ArrowRight />
              </ExternalLink>
            </FlexRow>
          </div>
        </Form>
      </WhiteCard>
    </BackpackThemedContentPanelWithFullHeader>
  );
}

export default GroupDeletedView;
